import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as kambiConfig } from "../Kambi/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  betFeed: "/betfeed/",
  bettingHistory: "/bets/b/",
  bettingRules: "/erste-schritte/sportwetten-regeln/",
  blog: "https://www.888sport.de/blog/",
  casinoUrl: "https://www.888casino.com/",
  casinoNativeUrl: "https://casino-www.888sport.com/",
  sportUrl: getSportUrl(),
  contactUs: `https://888-external-de.custhelp.com/app/home/p/243/`,
  help: "https://888-external-de.custhelp.com/app/home/p/243/",
  home: "/",
  liveChat:
    "https://888-external-de.custhelp.com/app/chat/chat_launch?chanel=888sport_de_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-de.custhelp.com/app/chat/chat_launch?chanel=888sport_de_vip&ChRefId=1",
  liveNow: "/live-wetten/",
  promotions: "/aktionen/",
  promotionsVIP: "/vip-sports-betting/current.htm",
  recommendations: "/recommendations/",
  madeForYou: {
    de: "/fursiegemacht/furheute/mfytoday/"
  },
  responsibleGaming: "/sicherheit-datenschutz/verantwortungsbewusstes-spielen",
  startingSoon: "/starting-soon/",
  survey: clientPage,
  pokerHistoryLink: "/app/pokerverlauf/"
};

export const config = { ...kambiConfig };
